import axios from "axios";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchLabelsSuccess } from "../components/Labels/actions";
import { urlLabels } from "../endpoints";
import { LabelsPayload } from "../components/Labels/types";

export const useLabels = () => {
  const dispatch = useDispatch();

  const [labels, setLabels] = useState<LabelsPayload>({});
  const [loading, setLoading] = useState(true);

  /* --- fallback if request fails ----------------------------------- */
  const setFallback = () => {
    setLabels({});
    setLoading(false);
  };

  /* --- call API ---------------------------------------------------- */
  const getLabelsInfo = async () => {
    try {
      const res = await axios.get<LabelsPayload>(urlLabels);
      return res.status === 200 ? res.data : undefined;
    } catch {
      return undefined;
    }
  };

  useEffect(() => {
    (async () => {
      const data = await getLabelsInfo();
      if (data) {
        setLabels(data);
        setLoading(false);
      } else {
        setFallback();
      }
    })();
  }, []);

  /* --- push to Redux only once data is present --------------------- */
  useEffect(() => {
    if (Object.keys(labels).length !== 0) {
      dispatch(fetchLabelsSuccess(labels));
    }
  }, [labels, dispatch]);

  return { labels, loading, setLabels };
};
